import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

function AppointmentPageTopInfo() {
  const { pathname } = useLocation();

  return (
    <>
      {pathname === "/appointment/review" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>
                ℹ️ Reviewing of recommended applications (Process 2 of 6)
              </strong>
              <br />
              <strong>Step 1 :</strong> Stats incharges raise the recommendation
              form
              <br />
              <strong>Step 2 :</strong> All leaders in the unit approve of this
              recommendation (Appointment Recommending Committee - ARC)
            </Typography>
          </Box>
        </Box>
      )}

      {pathname === "/appointment/apply" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>ℹ️ Raise the recommendation form (Process 1 of 6)</strong>
              <br />
              <strong>Step 1 :</strong> Stats incharges raise the recommendation
              form
              <br />
              <strong>Step 2 :</strong> All leaders in the same unit approve of
              this recommendation
            </Typography>
          </Box>
        </Box>
      )}
      {pathname === "/appointment/reviewcommittee" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>
                ℹ️ Level 1 Approval for applications (Process 3 of 6)
              </strong>
              <br />
              All leaders of Appointment Approving Committee (AAC) level 1
              submit their remarks & feedback for each application
            </Typography>
          </Box>
        </Box>
      )}
      {pathname === "/appointment/second-approval" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>
                ℹ️ Level 2 Approval for applications (Process 4 of 6)
              </strong>
              <br />
              All leaders of Appointment Approving Committee (AAC) level 2
              submit their remarks & feedback for each application
            </Typography>
          </Box>
        </Box>
      )}
      {pathname === "/appointment/mark" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>
                ℹ️ Mark Interaction for all applications (Process 5 of 6)
              </strong>
              <br />
              Upon approval of the AAC Level 2, relevant unit leaders conduct
              in-person interactions for the approved leaders. Stats incharges
              then mark interaction for the applications under this list. Once
              the interaction is marked, leaders receive a consent mail on the
              email ID mentioned in their BDS profile. As a next step, leaders
              give their consent in upholding the leadership responsibility.
            </Typography>
          </Box>
        </Box>
      )}
      {pathname === "/appointment/mark-appointment" && (
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#043d90",
            borderRadius: 2,
            boxShadow: 2,
            p: 2,
            mb: 5,
            border: "2px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              mb: 1,
              p: 1,
              backgroundColor: "primary.50",
              borderRadius: 2,
              borderLeft: 4,
              borderLeftColor: "yellow",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px !important",
                lineHeight: 1.6,
                color: "white",
              }}
            >
              <strong>
                ℹ️ Applications ready for appointment (Process 6 of 6)
              </strong>
              <br />
              This list shows all leaders who have given their consent and are
              willing to take up leadership in BSG. The respective stats
              incharge can see who all are ready to be appointed and thereby
              mark their appointments from Direct Appointment module, under
              appointment entry.
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}

export default AppointmentPageTopInfo;
